import { Component, inject, Input,  OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppStore, SnackbarWarningAction } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { BoudService } from 'projects/deusto-extension/src/lib/services/boud.service';
import { UdeuBoud } from 'projects/deusto-extension/src/lib/model/classes/udeu-boud';
import { TYPE_FIELD, SUBTYPE_FIELD, PRIMARY_APPROVING_BODY_FIELD, PROVISION_NUMBER_FIELD, ACTION_TYPE_FIELD, APPROVAL_DATE_FIELD, EFFECTIVE_DATE_FIELD } from 'projects/deusto-extension/src/lib/model/contants/udeu-boud';
import { MatDialog } from '@angular/material/dialog';
import { BoudElementFormComponent } from './element-form/element-form.component';
import { KeyValue } from '@angular/common';
import { actionTypeEnum } from 'projects/deusto-extension/src/lib/model/enums/boud-assoc-element-type';

@Component({
  selector: 'boud-elements',
  templateUrl: './elements.component.html',
  styleUrls: ['./elements.component.scss'],
})
export class BoudElementsComponent implements OnInit {
  @Input() group: FormGroup<any>;
  @Input() boud: UdeuBoud;
  @Input() actionType: string;
  @Input() disabled: boolean;
  
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;

  @ViewChild('mentionedForm') mentionedForm!: BoudElementFormComponent;
  @ViewChild('suspendedForm') suspendedForm!: BoudElementFormComponent;
  @ViewChild('modifiedForm') modifiedForm!: BoudElementFormComponent;
  @ViewChild('repealedForm') repealedForm!: BoudElementFormComponent;
  @ViewChild('correctedForm') correctedForm!: BoudElementFormComponent;

  @ViewChild('mentionerForm') mentionerForm!: BoudElementFormComponent;
  @ViewChild('modifierForm') modifierForm!: BoudElementFormComponent;
  @ViewChild('repealerForm') repealerForm!: BoudElementFormComponent;
  @ViewChild('suspenderForm') suspenderForm!: BoudElementFormComponent;
  @ViewChild('correctorForm') correctorForm!: BoudElementFormComponent;

  options: UdeuBoud[] = [];

  loading: boolean;
  

  private _formBuilder = inject(FormBuilder);
  formGroup: FormGroup<any>;

  actionTitle: string;
  
  assocElements: Map<string,UdeuBoud[]> = new Map();

  elementActionTypes = actionTypeEnum;

  actionOptions: KeyValue<string, string>[];
  selectedOption: KeyValue<string, string>;

  constructor(private boudService: BoudService, protected store: Store<AppStore>, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.formGroup = this.createForm();

    this.actionOptions = [
        { key: this.elementActionTypes.UDEU_BOUD_MENTION_ACTION_TYPE, value: 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.ELEMENTS.ACTION_TYPES.MENTION'}, 
        { key: this.elementActionTypes.UDEU_BOUD_CORRECTION_ACTION_TYPE, value: 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.ELEMENTS.ACTION_TYPES.CORRECT'},
        { key: this.elementActionTypes.UDEU_BOUD_MODIFICATION_ACTION_TYPE, value: 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.ELEMENTS.ACTION_TYPES.MODIFY'},
        { key: this.elementActionTypes.UDEU_BOUD_REPEAL_ACTION_TYPE, value: 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.ELEMENTS.ACTION_TYPES.REPEAL'},
        { key: this.elementActionTypes.UDEU_BOUD_SUSPENSION_ACTION_TYPE, value: 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.ELEMENTS.ACTION_TYPES.SUSPEND'}]

    this.selectedOption = this.actionOptions[0];    
  }

  createForm(boud?: UdeuBoud, title? : string): FormGroup<any> {
    return this._formBuilder.group({
      search: ['', [Validators.minLength(3)]],
      id: [{ value: boud?.id, disabled: true }],
      name: [{ value: boud?.name, disabled: true }],
      title: [{ value: title ?? boud?.content?.spanishContent?.title, disabled: true }],
      [TYPE_FIELD]: [{ value: boud?.data?.type, disabled: true }],
      [SUBTYPE_FIELD]: [{ value: boud?.data?.subtype, disabled: true }],
      [PRIMARY_APPROVING_BODY_FIELD]: [{ value: boud?.data?.primaryApprovingBody, disabled: true }],
      //[SECONDARY_APPROVING_BODY_FIELD]: [{ value: boud?.data?.secondaryApprovingBody, disabled: true }],
      //[SECONDARY_APPROVING_BODY_SUB_FIELD]: [{ value: boud?.data?.secondaryApprovingBodySub, disabled: true }],
      [PROVISION_NUMBER_FIELD]: [{ value: boud?.data?.provisionNumber, disabled: true }],
      [ACTION_TYPE_FIELD]: [{ value: boud?.data?.actionType, disabled: true }],
      [APPROVAL_DATE_FIELD]: [{ value: boud?.data?.approvalDate, disabled: true }],
      [EFFECTIVE_DATE_FIELD]: [{ value: boud?.data?.effectiveDate, disabled: true }],
    });
  }

  async searchElements() {
    const value = this.formGroup.get('search').value;
    if (typeof value === 'string' && value.length >= 3) {
      this.loading = true;
      this.autocompleteTrigger.closePanel();
      try {
        await this.boudService.getElements(value).then((elements) => {
          if(elements && Array.isArray(elements)) {
            this.options = elements?.filter((opt) => {
              return opt.id !== this.boud?.id
            });
          }
        });

        if (this.options?.length === 1) {
          const boudElement = this.options[0];
          this.formGroup.get('search').setValue(boudElement);
          this.addBoud(boudElement);
        } else {
          this.autocompleteTrigger.openPanel();
        }
      } catch (err) {
        console.error(err);
        this.store.dispatch(new SnackbarWarningAction('No se pudo obtener los elementos.'));
      } finally {
        this.loading = false;
      }
    } else if (value.length < 3) {
      this.resetForm();
    }
  }

  addBoud(boud: UdeuBoud) {
    this.formGroup.get('id').setValue(boud.id);
    this.formGroup.get('name').setValue(boud.name);
    this.formGroup.get('title').setValue(boud.content?.spanishContent?.title);
    this.formGroup.get(TYPE_FIELD).setValue(boud.data?.type);
    this.formGroup.get(SUBTYPE_FIELD).setValue(boud.data?.subtype);
    this.formGroup.get(PRIMARY_APPROVING_BODY_FIELD).setValue(boud.data?.primaryApprovingBody);
   // this.formGroup.get(SECONDARY_APPROVING_BODY_FIELD).setValue(boud.data?.secondaryApprovingBody);
    //this.formGroup.get(SECONDARY_APPROVING_BODY_SUB_FIELD).setValue(boud.data?.secondaryApprovingBodySub);
    this.formGroup.get(PROVISION_NUMBER_FIELD).setValue(boud.data?.provisionNumber);
    this.formGroup.get(ACTION_TYPE_FIELD).setValue(boud.data?.actionType);
    this.formGroup.get(APPROVAL_DATE_FIELD).setValue(boud.data?.approvalDate);
    this.formGroup.get(EFFECTIVE_DATE_FIELD).setValue(boud.data?.effectiveDate);
    
    if(this.elementActionTypes.UDEU_BOUD_CORRECTION_ACTION_TYPE == this.selectedOption.key){
      this.assocElements[this.elementActionTypes.UDEU_BOUD_MENTION_ACTION_TYPE] = boud.elements.mentionedElements;
      this.assocElements[this.elementActionTypes.UDEU_BOUD_CORRECTION_ACTION_TYPE] = boud.elements.correctedElements;
      this.assocElements[this.elementActionTypes.UDEU_BOUD_MODIFICATION_ACTION_TYPE] = boud.elements.modifiedElements;
      this.assocElements[this.elementActionTypes.UDEU_BOUD_REPEAL_ACTION_TYPE] = boud.elements.repealedElements;
      this.assocElements[this.elementActionTypes.UDEU_BOUD_SUSPENSION_ACTION_TYPE] = boud.elements.suspendedElements;
    }
  }

  displayFn(boud: UdeuBoud): string {
    const title = boud?.content?.spanishContent?.title;
    return boud ? `${boud.name}` + `${ title ? ' - ' + title.substring(0, 50) + (title.length > 50 ? '...' : '') : ''}` : '';
  }

  isSelected(option: UdeuBoud, controlName: string): boolean {
    const value = this.formGroup.get(controlName).value;
    return value && typeof option !== 'string' ? value === option : false;
  }
  
  add(){
    const actionType = this.selectedOption.key;
    
    const title = this.formGroup.get('title').value;
    const boud = new UdeuBoud();
    boud.id = this.formGroup.get('id').value;
    boud.name = this.formGroup.get('name').value;
    boud.data.type = this.formGroup.get(TYPE_FIELD).value;
    boud.data.subtype = this.formGroup.get(SUBTYPE_FIELD).value;
    boud.data.primaryApprovingBody = this.formGroup.get(PRIMARY_APPROVING_BODY_FIELD).value;
   // boud.data.secondaryApprovingBody = this.formGroup.get(SECONDARY_APPROVING_BODY_FIELD).value;
   // boud.data.secondaryApprovingBodySub = this.formGroup.get(SECONDARY_APPROVING_BODY_SUB_FIELD).value;
    boud.data.provisionNumber = this.formGroup.get(PROVISION_NUMBER_FIELD).value;
    boud.data.actionType = this.formGroup.get(ACTION_TYPE_FIELD).value;
    boud.data.approvalDate = this.formGroup.get(APPROVAL_DATE_FIELD).value;
    boud.data.effectiveDate = this.formGroup.get(EFFECTIVE_DATE_FIELD).value;

    switch (actionType) {
      case actionTypeEnum.UDEU_BOUD_CORRECTION_ACTION_TYPE:
        this.correctedForm.add(boud, title);
        this.correctedForm.addSubelements(this.assocElements[actionTypeEnum.UDEU_BOUD_CORRECTION_ACTION_TYPE]);
        break;

      case actionTypeEnum.UDEU_BOUD_REPEAL_ACTION_TYPE:
        this.repealedForm.add(boud, title);
        this.repealedForm.addSubelements(this.assocElements[actionTypeEnum.UDEU_BOUD_REPEAL_ACTION_TYPE]);
        break;

      case actionTypeEnum.UDEU_BOUD_MODIFICATION_ACTION_TYPE:
        this.modifiedForm.add(boud, title);
        this.modifiedForm.addSubelements(this.assocElements[actionTypeEnum.UDEU_BOUD_MODIFICATION_ACTION_TYPE]);
        break;

      case actionTypeEnum.UDEU_BOUD_SUSPENSION_ACTION_TYPE:
        this.suspendedForm.add(boud, title);
        this.suspendedForm.addSubelements(this.assocElements[actionTypeEnum.UDEU_BOUD_SUSPENSION_ACTION_TYPE]);
        break;
    
      default:
        this.mentionedForm.add(boud, title);
        this.mentionedForm.addSubelements(this.assocElements[actionTypeEnum.UDEU_BOUD_MENTION_ACTION_TYPE]);
        break;
    }

    this.resetForm();
  }

  resetForm() {
    this.options = [];

    this.formGroup.reset();
    this.formGroup.setErrors(null);
    this.formGroup.markAsUntouched();
  }

  hasSomeElement(){
    return (this.mentionedForm && this.mentionedForm.formArray.length > 0)
    || (this.mentionedForm && this.modifiedForm.formArray.length > 0)
    || (this.repealedForm && this.repealedForm.formArray.length > 0)
    || (this.correctedForm && this.correctedForm.formArray.length > 0)
    || (this.suspendedForm && this.suspendedForm.formArray.length > 0)  
  }
  
  hasSomeReference() {
    return this.boud?.references?.mentionersElements?.length > 0
    || this.boud?.references?.suspendersElements?.length > 0
    || this.boud?.references?.modifiersElements?.length > 0
    || this.boud?.references?.repealersElements?.length > 0
    || this.boud?.references?.correctorsElements?.length > 0
  }

}
